import { render, staticRenderFns } from "./notFond.vue?vue&type=template&id=be714570&scoped=true&"
import script from "./notFond.vue?vue&type=script&lang=js&"
export * from "./notFond.vue?vue&type=script&lang=js&"
import style0 from "./notFond.vue?vue&type=style&index=0&id=be714570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be714570",
  null
  
)

export default component.exports